import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "./Footer/Footer";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import TosPopup from "@_components/popups/TosPopup/TosPopup";
import styles from "./Layout.module.css";
import { authService } from "@_services/auth.service";
import { getUserDataFromJwt } from "@_utils/helpers";
import { emailActions } from "@_actions/email_flows.actions";
import { subscriptionActions } from "@_actions/subscription.actions";
import { userActions } from "@_actions/user.actions";
import { routeConstants } from "@_constants/route.constants";
import { emailsActions } from "@_actions/emails.actions";

function Layout(props) {
  const dispatch = useDispatch();

  const [openTosPopup, setOpenTosPopup] = useState(false);
  const [tosData, setTosData] = useState(null);

  const authReducer = useSelector((state) => state.authReducer);

  const showSidebar =
    authReducer.user &&
    !routeConstants.PUBLIC_PATHS.includes(window.location.pathname);

  useEffect(checkTosStatus, []);

  useEffect(() => {
    if (authReducer.user) {
      dispatch(userActions.getSignature());
    } else return;
  }, [dispatch, authReducer.user]);

  useEffect(() => {
    if (authReducer.user) {
      dispatch(emailActions.getEmail());
      dispatch(emailsActions.loadEmails());
    } else return;
  }, [dispatch, authReducer.user]);

  useEffect(() => {
    if (authReducer.user) {
      dispatch(subscriptionActions.getSubscriptionConfig());
    } else return;
  }, [dispatch, authReducer.user]);

  function checkTosStatus() {
    if (getUserDataFromJwt().user_role === "ADMIN") {
      authService.getTos().then(
        (results) => {
          if (!results.current_tos_accepted) {
            // If the latest TOS is not accepted
            setTosData(results);
            setOpenTosPopup(true);
          }
        },
        (error) => {
          // TODO alert user
        }
      );
    }
  }

  function tosClosed() {
    setOpenTosPopup(false);
  }
  return (
    <div className={styles.root}>
      <Header loggedIn={authReducer.user} />
      {showSidebar && <Sidebar />}
      <div className={showSidebar ? styles.content : styles.content_no_user}>
        {props.children}
      </div>
      <Footer />
      <TosPopup open={openTosPopup} close={tosClosed} data={tosData} />
    </div>
  );
}

export default Layout;
